module.exports = __webpack_public_path__ + "img/bolsas.64d649f2.png";